import { useEffect } from 'react';
import { Location, useLocation } from 'react-router-dom';

import { RouteNameEnum } from '../enums';
import { UseRedirectTo } from '../interfaces';

import { useRedirectTo } from './useRedirectTo.hook';

export const useRedirects: () => void = (): void => {
  const { hash }: Location = useLocation();
  const { redirect }: UseRedirectTo = useRedirectTo();

  useEffect(
    (): void => {
      if (hash.startsWith('#rejestracja')) {
        const token: string | undefined = hash.split('/')[1];
        if (token) {
          redirect({
            route: RouteNameEnum.PreAccountRegistration,
            params: { hash: token },
            replace: true,
          });
        } else {
          redirect({ route: RouteNameEnum.Registration, replace: true });
        }
      }
    },
    [redirect, hash]
  );
};
